import React from 'react';
import CardKeyValue from '../../../../../card/cardKeyValue';
import FormatDate from '../../../../../date/FormatDate';

const BasicInformation = ({ detail }) => (
  <div className='flex flex-nowrap gap-4 pb-2 items-strech justify-center overflow-auto'>
    {detail?.name && (
      <CardKeyValue className='min-w-100px max-w-150px' title='Assessment Name' value={detail.name || ''} />
    )}
    {detail?.date && (
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Date'
        value={detail.date ? <FormatDate date={detail.date} /> : ''}
      />
    )}
    {detail?.sittingDate && (
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Sitting Date'
        value={detail.sittingDate ? <FormatDate date={detail.sittingDate} /> : ''}
      />
    )}

    {detail?.template && (
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Template'
        value={detail.template?.title || ''}
      />
    )}

    {detail?.notes && (
      <CardKeyValue className='min-w-100px max-w-150px' title='Notes' value={detai?.notes || ''} />
    )}
  </div>
);

export default BasicInformation;
